<template lang="pug">
  .ParagraphMap
    .ParagraphMap_wrapper
      .ParagraphMap_mapContainer
        gmap-map(:center='center', :zoom='12', v-if="center", v-bind:options="mapOptions", class="ParagraphMap_map")
          gmap-marker(:key='index', v-for='(m, index) in markers', :position='m.position', icon="/img/ui/map_marker.svg" @click='openInfoWindowTemplate(m)')
          gmap-info-window(v-if="infoWindow" :options="{maxWidth: 300}" :position="infoWindow.position" :opened="infoWindow.open" @closeclick="infoWindow.open=false")
            div(v-html="infoWindow.template")

      MediaLegend(
        :items="legendItems"
      )

</template>

<script>

import MediaLegend from '@/components/MediaLegend'
import mapStyle from '@/components/paragraphs/ParagraphMap_style'

export default {
  components: {
    MediaLegend
  },
  props: ['item'],
  data () {
    return {
      markers: null,
      infoWindow: null,
      center: 0
    }
  },
  watch:
  {
    markers () {
      this.center = this.markers ? this.markers[0].position : null
    }
  },
  computed: {
    legendItems () {
      return [ this.item.title ]
    },
    mapOptions () {
      return {styles: mapStyle}
    }
  },
  methods: {
    openInfoWindowTemplate (item) {
      this.center = item.position
      this.infoWindow = {}
      this.setInfoWindowTemplate(item)
      this.infoWindow.position = item.position
      this.infoWindow.open = true
    },
    setInfoWindowTemplate (item) {
      this.infoWindow.template = '<div id="content">' +
            '<p class="InfoWindow_title">' + item.title + '</p>' +
            '<div class="InfoWindow_content">' +
            '<p>' + item.position.lat + ' / ' + item.position.lng + '</p>' +
            '</div>' +
            '</div>'
    }
  },
  mounted () {
    this.markers = this.item.markers.map((el) => {
      return {
        title: el.title,
        position: { lat: el.coordinates.lat, lng: el.coordinates.lng }
      }
    })
  }
}

</script>

<style lang="stylus">

.gm-style .gm-style-iw
  background-color: #000000 !important;
  top: 0 !important;
  left: 0 !important;
  width: 240px !important;
  // height: 100% !important;
  min-height: 120px !important;
  padding: 30px !important;
  display: block !important;
  box-sizing border-box !important;
  bottom 0px !important;
  position: absolute !important;
  left: 50% !important;
  transform: translate3d( -50%, 0, 0 )

  & > div

    display block !important

  &:after
    content ' '
    position absolute
    pointer-events none
    display block
    top 7px
    left 7px
    bottom 7px
    right 7px
    border 1px solid $beige

  p.InfoWindow_title

    text-transform uppercase
    font-size 16px
    color white

    &:after
      content ' '
      display block
      position relative
      width 45px
      margin 11px 0px
      border-bottom 1px solid white

  .InfoWindow_content

    color white
    opacity .5

    p
      margin 15px 0
      font-size 14px

      &:last-child
        margin auto

/*style the p tag*/
.gm-style .gm-style-iw #google-popup p
  padding: 10px;

/*style the arrow*/
// .gm-style div div div div div div div div
//   background-color: #000000 !important;
//   padding: 0;
//   margin: 0;
//   padding: 0;
//   top: 0;
//   color: #fff;
//   font-size: 16px;

// .gm-style > div > div > div > div > div > div:first-child > div
//   display none
// .gm-style > div > div > div > div > div > div:first-child > div
//   display block
.gm-style > div > div > div > div > div > div:first-child > div > div div
  background-color: #000000 !important;
  box-shadow: none !important;

/*style the link*/
.gm-style div div div div div div div div a
  color: #000000;
  font-weight: bold;

</style>

<style lang="stylus" scoped>

.ParagraphMap
  margin: 3.75vw 0

  &_wrapper
    max-width: 1100px
    margin 0 auto

  &_mapContainer
    position: relative

    &::before
      display: block
      position: relative
      content ''
      padding-bottom ((9/16)*100) + '%'

  &_map
    position: absolute
    top 0
    right 0
    bottom 0
    left 0
    background-color $grey-2
    color $beige
    display: flex
    align-items: center
    justify-content: center

</style>
